import React from 'react'

export const Messenger = () => {
  return (
    <div className="col-lg-9 col-12">
      <div className="editProfileBlock">
        <div className="prodileDetailsBlock mt-3">

          <div className="basicDetailTlt">
            <p>Messenger</p>
          </div>

          <div className="blackTxt mt-3">
            <p>My Conversations</p>
          </div>

          <div className="d-flex justify-content-between align-items-between msgBG">

            <div className="d-flex align-items-between">
              <div className="flex-shrink-0">
                <a href="chat_messenger.html"><img src="images/girlImgCircle.png" /></a>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="chatName">Ruchita Jadhav</p>
                <p>Hello</p>
              </div>
            </div>
            <div><p>40 m ago</p></div>
          </div>
          <div className="d-flex justify-content-between align-items-between msgBG">
            <div className="d-flex align-items-between">
              <div className="flex-shrink-0">
                <a href="chat_messenger.html"><img src="images/blankPic3.png" /></a>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="chatName">Ruchita Jadhav</p>
                <p>Hi</p>
              </div>
            </div>
            <div><p>1 d ago</p></div>
          </div>
          <div className="d-flex justify-content-between align-items-between msgBG">
            <div className="d-flex align-items-between">
              <div className="flex-shrink-0">
                <a href="chat_messenger.html"><img src="images/girlImgCircle3.png" /></a>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="chatName">Ruchita Jadhav</p>
                <p>Good Afternoon</p>
              </div>
            </div>
            <div><p>7/10/2024</p></div>
          </div>
          <br />
        </div>
      </div>
    </div>
  )
}
